//import Vue from 'vue';
// import {
//     Button,
//     Table,
//     TableColumn,
//     Tabs,
//     TabPane,
//     Menu,
//     MenuItem,
//     Breadcrumb,
//     BreadcrumbItem,
//     Form,
//     FormItem,
//     Row,
//     Col,
//     Radio,
//     RadioGroup,
//     RadioButton,
//     Input,
//     Pagination,
//     Popover,
//     Dialog,
//     Upload,
//     Option,
//     Message,
//     MessageBox,
//     Cascader,
//     Progress,
//     Tree,
//     Avatar,
//     Dropdown,
//     DropdownMenu,
//     DropdownItem,
//     Carousel,
//     CarouselItem,
//     Image
// } from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import App from './App';
import { router } from './router';
import './style/base.less'
import './style/iconfont/iconfont.css'
import './style/iconfont/iconfont.js'
import 'lib-flexible'
import store from './store'

import '../public/static/ueditor/ueditor.config.js'
import '../public/static/ueditor/ueditor.all.min.js'
import '../public/static/ueditor/lang/zh-cn/zh-cn.js'
import '../public/static/ueditor/ueditor.parse.min.js'


Vue.use(ELEMENT)
Vue.config.productionTip = false
    // Vue.use(Button)
    // Vue.use(Table)
    // Vue.use(TableColumn)
    // Vue.use(Tabs)
    // Vue.use(Menu)
    // Vue.use(MenuItem)
    // Vue.use(Breadcrumb)
    // Vue.use(BreadcrumbItem)
    // Vue.use(Form)
    // Vue.use(Row)
    // Vue.use(Col)
    // Vue.use(Radio)
    // Vue.use(RadioGroup)
    // Vue.use(RadioButton)
    // Vue.use(Input)
    // Vue.use(Pagination)
    // Vue.use(Popover)
    // Vue.use(Dialog)
    // Vue.use(FormItem)
    // Vue.use(TabPane)
    // Vue.use(Upload)
    // Vue.use(Cascader)
    // Vue.use(Progress)
    // Vue.use(Option)
    // Vue.use(Tree)
    // Vue.use(Avatar)
    // Vue.use(Dropdown)
    // Vue.use(DropdownMenu)
    // Vue.use(DropdownItem)
    // Vue.use(Carousel)
    // Vue.use(CarouselItem)
    // Vue.use(Image)
    // Vue.prototype.$message = Message
    // Vue.prototype.$confirm = MessageBox.confirm;
    // Vue.prototype.$alert = MessageBox.alert
    import moment from 'moment'
    Vue.prototype.$moment = moment

new Vue({
    router,
    store,
    el: '#app',
    render: h => h(App)
});